import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import App from './App.vue'
import pinia from './store/store'
import router from './router'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import VueUeditorWrap from "vue-ueditor-wrap"
import * as echarts from 'echarts'

const app = createApp(App)
app.use(ElementPlus, {
  locale: zhCn,
})
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.config.globalProperties.$echarts = echarts
app.use(VueUeditorWrap).use(pinia).use(router).mount('#app')
